import { Link } from "react-router-dom";

const CARDS = [
  {
    title: "Private & Confidential",
    body: "Your information is protected with the utmost care and never shared.",
    to: "/safety#verification",
    left: "4.7%",
    width: "21.3%",
  },
  {
    title: "Secure by Design",
    body: "Advanced, layered security built into every detail from the ground up.",
    to: "/safety#reports",
    left: "28.4%",
    width: "19.6%",
  },
  {
    title: "Safety You Can Trust",
    body: "Rigorous standards. Proven protocols. Peace of mind you deserve.",
    to: "/safety#control",
    left: "50.5%",
    width: "19.9%",
  },
  {
    title: "Support When You Need It",
    body: "Discreet, responsive support available when it matters most.",
    to: "/safety#trust-safety",
    left: "72.8%",
    width: "19.9%",
  },
];

export const SafetyPillars = () => (
  <section className="bg-[#F9F1E4] py-10" data-testid="safety-pillars-section">
    <h2 className="sr-only" data-testid="safety-pillars-headline">
      Discretion Comes First.
    </h2>
    <p className="sr-only" data-testid="safety-pillars-overline">
      Elevated protection. Quiet confidence.
    </p>
    <div className="relative mx-auto w-full max-w-[960px]">
      <img
        src="/assets/safety-section.jpg"
        alt="Discretion comes first. Four promises: private and confidential, secure by design, safety you can trust, and support when you need it."
        className="block h-auto w-full"
      />
      {CARDS.map((card, i) => (
        <Link
          key={card.title}
          to={card.to}
          data-testid={`safety-pillar-card-${i + 1}`}
          aria-label={`${card.title}. ${card.body}`}
          className="absolute top-[36%] block h-[58%] rounded-[1.6%]"
          style={{ left: card.left, width: card.width }}
        />
      ))}
    </div>
  </section>
);
